import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

import App from './App';
import { store } from './store';
import { ResponsiveProvider } from './providers/ResponsiveProvider';
import { queryClient } from './config/queryClient'; // ⭐ 修改：使用全局QueryClient配置
import './index.css';
import './styles/theme-tech.css';
import './styles/theme-glass.css';
import './styles/theme-neumorph.css';
import './styles/themes/glass.css';
import './styles/themes/cyber.css';
import './styles/themes/neumorph.css';

// 设置dayjs中文语言
dayjs.locale('zh-cn');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ResponsiveProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ResponsiveProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);